import { TYPES } from './actions';
import { merge } from '../../../../utils/state';

const initialState = {
  isLoading: false,
  error: null,
  isEmployerProfile: null,
  jobcaseEmployerAdminLevel: false,
  hasMultipleEmployers: null,
  currentEmployer: null,
  currentSubEmployer: null,
  grants: null,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPES.GET_EMPLOYER_PROFILE_REQUEST:
      return merge(state, {
        isLoading: true,
      });
    case TYPES.SET_IS_EMPLOYER_PROFILE:
      return merge(state, {
        isEmployerProfile: action.payload,
        isLoading: false,
      });
    case TYPES.SET_HAS_MULTIPLE_EMPLOYERS:
      return merge(state, {
        hasMultipleEmployers: action.payload,
        isLoading: false,
      });
    case TYPES.SET_EMPLOYER_GRANTS:
      return merge(state, {
        grants: action.payload,
        isLoading: false,
      });
    case TYPES.SET_EMPLOYER_GRANTS_BY_ID:
      return merge(state, {
        grants: { ...state.grants, [action.payload.employerKey]: [...action.payload.grants] },
      });
    case TYPES.GET_EMPLOYER_PROFILE_SUCCESS:
      return merge(state, {
        currentEmployer: action.payload.employerId,
        currentSubEmployer: action.payload.subEmployerId,
        isLoading: false,
      });
    case TYPES.GET_EMPLOYER_PROFILE_ERROR:
      return merge(state, {
        isEmployerProfile: false,
        error: action.payload,
      });
    case TYPES.SET_IS_JOBCASE_EMPLOYER_ADMIN:
      return merge(state, {
        jobcaseEmployerAdminLevel: action.payload,
      });
    default:
      return state;
  }
};

export default reducer;
